import React, { type FC } from 'react'

interface IconBanRegularProps {
  width?: string
  height?: string
  fill?: string
}

const IconBanRegular: FC<IconBanRegularProps> = (
  { width, height, fill } = { fill: 'currentColor' },
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        shapeRendering="geometricPrecision"
        d="M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
      />
    </svg>
  )
}

export default IconBanRegular
